import React from 'react';

const Table = props => (
  <div className="module-table top">
    <table className="auto">
      <thead>
        <tr>
          <th className="bd left">
            <a onClick={props.handleSort}>
              {props.language.account.accountUser.name} <i className="fas fa-arrows-alt-v" />
            </a>
          </th>
          <th className="th200 left"> {props.language.account.accountUser.email} </th>
          {props.tags.map(item => (
            <th className="left" key={item}>
              {props.language.filter[item.toLowerCase()]}
            </th>
          ))}
          <th className="left">
            {props.language.account.accountUser.rol}
            <div>
              <i className="fas fa-question-circle" />
              <span>{props.language.account.accountUser.rolLabel}</span>
            </div>
          </th>
          <th className="th100">{props.language.account.accountUser.actions}</th>
        </tr>
      </thead>
      <tbody>
        {props.datos.map((item, i) => (
          <tr key={`row-${i}`}>
            <td className={!item.state ? 'bd-gray' : 'bd-green'}>{item.name}</td>

            <td>{item.userName}</td>
            {props.tags.map(tags => {
              const index = item.filterTags
                .map(function (e) {
                  return e.tagCategory;
                })
                .indexOf(tags.toUpperCase());
              return (
                <td key={tags}>
                  {index >= 0
                    ? item.filterTags.filter((child) => child.tagCategory.toUpperCase() == tags.toUpperCase())
                      .map((child, i) => {
                        return child.tag == '*' ? props.language.all: child.tag;
                    }).join(", ")
                    : ''}
                </td>
              );
            })}
            <td>
              {item.roles.map((item, i) => {
                return <p key={i}>{props.language.account.accountUser[item.toLowerCase()]}</p>;
              })}
            </td>
            <td>
              {!item.system && (
                <div className="button-setting flex justify-center">
                  {
                    item.state &&
                    <div>
                      <a>
                        <span className="hover-title">
                          {' '}
                          {props.language.account.geozone.modalEdit.editText}
                        </span>{' '}
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          data-username={item.userName}
                          data-option="edit"
                          onClick={props.handleModal}
                          className="fas fa-edit"
                        />{' '}
                      </a>
                    </div>}
                  {item.state ? (
                    <div>
                      <a>
                        <span className="hover-title">
                          {' '}
                          {props.language.account.geozone.modalEdit.deactivateText}
                        </span>{' '}
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          data-username={item.userName}
                          data-option="deactivate"
                          onClick={props.handleModalDelete}
                          className="fas fa-ban"
                        />{' '}
                      </a>
                    </div>
                  ) : (
                      <div>
                        <a>
                          <span className="hover-title">
                            {' '}
                            {props.language.account.geozone.modalEdit.activateText}
                          </span>{' '}
                          <i
                            data-datos={JSON.stringify(item)}
                            data-close="ok"
                            data-username={item.userName}
                            data-option="activate"
                            onClick={props.handleModalActive}
                            className="fas fa-smile"
                          />{' '}
                        </a>
                      </div>
                    )}
                  {
                    item.state &&
                    <div>
                      <a>
                        <span className="hover-title">
                          {props.language.account.accountUser.editPassWord}
                        </span>{' '}
                        <i
                          data-datos={JSON.stringify(item)}
                          data-close="ok"
                          data-username={item.userName}
                          data-option="editPassword"
                          onClick={props.handleModalPass}
                          className="fas fa-lock"
                        />{' '}
                      </a>
                    </div>
                  }
                </div>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
    {props.loadingTable && (
      <div className="loading-table">
        <h6>
          <i className="fas fa-spinner fa-spin" />
        </h6>
      </div>
    )}
    {props.pag >= props.count.pages && (
      <div className="loading-table">
        <h6>
          {props.datos.length > 0 ? props.language.account.accountUser.endOfTime : props.language.account.others.noData}
        </h6>
      </div>
    )}
  </div>
);

export default Table;



// WEBPACK FOOTER //
// ./source/client/components/account_user/table.jsx